// Removed MUI imports
import PropTypes from "prop-types";

const Tags = ({
  className = "",
  colour = "Primary",
  content = "Text Only",
  emphasis = "High Emphasis",
}) => {
  return (
    <div
      className={`rounded-8xs-3 bg-base-200 flex flex-row items-center justify-center py-[5.4px] px-[6.4px] gap-[2.1px] text-center text-5xs-5 text-base-content/50 font-body-m ${className}`}
      data-colour={colour}
      data-content={content}
      data-emphasis={emphasis}
    >
      <img className="h-[8.6px] w-[8.6px] relative" alt="" src="/icon-1.svg" />
      <div className="h-[11px] w-12 relative leading-[10.7px] flex items-center justify-center">
        Return Value
      </div>
    </div>
  );
};

Tags.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  colour: PropTypes.number,
  content: PropTypes.number,
  emphasis: PropTypes.number,
};

export default Tags;
